
import formatMoney from "accounting-js/lib/formatMoney.js";


function formatToMoney(value) {
    if (value) {
        return formatMoney(parseFloat(value), {
            symbol: "Rp. ",
            precision: 0,
            thousand: ".",
            decimal: ","
        });
    }
    return ''
}

export default formatToMoney